import React from 'react'
import ReactDOM from 'react-dom/client'
import { Mid } from '@mid/sdk'
import './index.css'
import './Layout/App.css'
import LoginWrapper from './Components/LoginWrapper'
import config from './config'
import LoadingPage from './Layout/Login'
import Home from './Containers/Home'
import './styles/Colors.css'
import { BrowserRouter } from 'react-router-dom'

const mid = new Mid({
  redirectUrl: `${config.redirectBaseUrl}/${config.subPath}/auth/callback`,
  logoutRedirectUrl: `${config.redirectBaseUrl}/${config.subPath}/logout`,
  loginInfo: {
    appId: config.clientId,
    oidcConfigUrl: config.oidcConfigUrl,
    authDriver: 'mid',
  },
  async landingFn(): Promise<void> {
    window.location.hash = ''
    // window.location.pathname = ''
  },
})

const root = ReactDOM.createRoot(document.getElementById('root')  as HTMLElement);

root.render(
  <LoginWrapper mid={mid} loadingNode={(props) => <LoadingPage {...props} />}>
    <BrowserRouter>
      <Home />
    </BrowserRouter>
  </LoginWrapper>
);